import React from "react";
import { NavLink } from "react-router-dom";

export const AppNavLink = (props) => (
  <NavLink style={{ textDecoration: "none", ...props.style }} {...props} />
);
